import { useCallback, useMemo } from 'react'
import { createMessageApiService, type MessageApiService } from '../services/api-service'
import { useMessageComponents } from '../components/message-components-provider'

/**
 * Custom hook to get a configured API service instance
 * This ensures consistent configuration across components
 */
export function useMessageApi(): MessageApiService {
  const { config } = useMessageComponents()

  // Create a unified token getter function using useMemo
  const tokenGetter = useCallback(() => {
    if (typeof config.userToken === 'function') {
      return config.userToken()
    }
    return config.userToken

  }, [config.userToken])

  return useMemo(() => createMessageApiService({
    apiEndpoint: config.apiEndpoint,
    userToken: tokenGetter
  }), [config.apiEndpoint, tokenGetter])
}
